export default "__VITE_ASSET__DUbJCZhW__"